import request from '@/utils/request'

// 获取API列表
export function GetApiList(data) {
  return request({
    url: '/car/api/data',
    method: 'post',
    data
  })
}
// 获取API排序列表
export function GetSortList() {
  return request({
    url: '/car/api/sortList',
    method: 'post'
  })
}
// 获取API详情
export function GetApiDetail(data) {
  return request({
    url: '/car/api/getDetail',
    method: 'post',
    data
  })
}

// 获取菜单数据
export function GetApiMenu() {
  return request({
    url: '/car/api/getMenu',
    method: 'post'
  })
}

// 保存API数据
export function saveData(data) {
  return request({
    url: '/car/api/saveData',
    method: 'post',
    data
  })
}

// 查询API数据
export function getApiDetail(data) {
  return request({
    url: '/car/api/getApiDetail',
    method: 'post',
    data
  })
}

// 更新API数据
export function updateApiData(data) {
  return request({
    url: '/car/api/updateApiData',
    method: 'post',
    data
  })
}

// 删除API数据
export function deleteApiData(data) {
  return request({
    url: '/car/api/deleteApiData',
    method: 'post',
    data
  })
}